import styled from 'styled-components'

// export const ImportBody = styled.div`
//     font-size: 14px;
//     .importLabel {
//         margin-top: 8px;
//         font-size: 16px;
//         cursor: pointer;
//         .file-input {
//             display: none;
//         }
//     }
// `
export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
`
